import { render, staticRenderFns } from "./assignNurse.vue?vue&type=template&id=0116fbe5&"
import script from "./assignNurse.vue?vue&type=script&lang=js&"
export * from "./assignNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports